import styled from 'styled-components';

export const DropdownSection = styled.div`
	margin-bottom: 12px;

	&:last-child {
		margin-bottom: 0;
	}
`;

export const SectionHeader = styled.div`
	font-size: 11px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[400]};
	text-transform: uppercase;
	letter-spacing: 0.05em;
	margin: 16px 0 8px;

	&:first-of-type {
		margin-top: 0;
	}
`;

export const NoDsRow = styled.button`
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 8px;
	border-radius: 6px;
	font-size: 13px;
	font-family: inherit;
	color: ${({ theme }) => theme.gray[600]};
	background: none;
	border: none;
	width: 100%;
	text-align: left;
	transition: background 0.2s;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;

export const EmptyState = styled.div`
	text-align: center;
	padding: 16px;
	color: ${({ theme }) => theme.gray[600]};
	font-size: 13px;
	border-radius: 6px;
`;

export const MobileEmptyState = styled.div`
	text-align: center;
	padding: 10px 16px;
	color: ${({ theme }) => theme.gray[600]};
	font-size: 13px;
	line-height: 1.5;
	border-radius: 6px;
`;

export const CreateButton = styled.button`
	background: linear-gradient(135deg, #1e90ff 0%, #4169e1 100%);
	color: white;
	border: none;
	padding: 12px 20px;
	font-weight: 600;
	font-size: 15px;
	cursor: pointer;
	width: 100%;
	border-radius: 8px;
	white-space: nowrap;
	box-shadow: 0 4px 12px rgba(30, 144, 255, 0.25), 0 2px 4px rgba(0, 0, 0, 0.3);
	transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
	position: relative;
	overflow: hidden;

	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, transparent 100%);
		opacity: 0;
		transition: opacity 0.2s ease;
	}

	&:hover:not([disabled]) {
		transform: translateY(-2px);
		box-shadow: 0 6px 16px rgba(30, 144, 255, 0.35), 0 4px 8px rgba(0, 0, 0, 0.4);
	}

	&:hover:not([disabled])::before {
		opacity: 1;
	}

	&:active:not([disabled]) {
		transform: translateY(-1px);
		box-shadow: 0 3px 10px rgba(30, 144, 255, 0.3), 0 2px 4px rgba(0, 0, 0, 0.3);
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
		transform: none;
		box-shadow: none;
	}
`;

export const SearchContainer = styled.div`
	position: relative;
	margin-top: 16px;
	margin-bottom: 12px;
	display: block;
	width: 100%;
`;

export const SearchInput = styled.input<{ isMobile?: boolean }>`
	width: 100%;
	height: 36px;
	box-sizing: border-box;
	background: ${({ theme }) => theme.gray[200]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 6px;
	padding: 0 36px 0 36px;
	font-size: ${({ isMobile }) => (isMobile ? '16px' : '13px')};
	color: ${({ theme }) => theme.gray[1000]};
	font-family: inherit;
	transition: border-color 0.2s;

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.blue[500]};
	}

	&::placeholder {
		color: ${({ theme }) => theme.gray[400]};
	}
`;

export const SearchIcon = styled.div`
	position: absolute;
	left: 12px;
	top: 50%;
	transform: translateY(-50%);
	color: ${({ theme }) => theme.gray[400]};
	pointer-events: none;
	display: flex;
	align-items: center;
`;

export const SearchCount = styled.div`
	font-size: 11px;
	color: ${({ theme }) => theme.gray[400]};
	margin-top: 6px;
`;

export const ClearButton = styled.button`
	position: absolute;
	right: 8px;
	top: 50%;
	transform: translateY(-50%);
	padding: 4px;
	border: none;
	background: none;
	color: ${({ theme }) => theme.gray[400]};
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
	transition: background-color 0.2s ease, color 0.2s ease;

	&:hover {
		background-color: ${({ theme }) => theme.gray[200]};
		color: ${({ theme }) => theme.gray[1000]};
	}
`;

export const ScrollArea = styled.div`
	max-height: 170px;
	overflow-y: auto;
	margin: 0 -8px;
	padding: 0 8px;
	position: relative;

	&::-webkit-scrollbar {
		width: 6px;
	}

	&::-webkit-scrollbar-track {
		background: transparent;
	}

	&::-webkit-scrollbar-thumb {
		background: ${({ theme }) => theme.gray[200]};
		border-radius: 3px;
	}

	&::-webkit-scrollbar-thumb:hover {
		background: ${({ theme }) => theme.gray[400]};
	}
`;

export const ShowcaseDivider = styled.div`
	height: 1px;
	background: ${({ theme }) => theme.gray[200]};
	margin: 12px 0;
`;

export const BrowseShowcaseButton = styled.button`
	background: none;
	border: none;
	color: ${({ theme }) => theme.gray[1000]};
	font-size: 12px;
	font-weight: 500;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	padding: 8px 12px;
	border-radius: 6px;
	transition: background 0.2s;
	width: 100%;
	text-align: left;
	font-family: inherit;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;

export const BrowseShowcaseArrow = styled.span`
	color: ${({ theme }) => theme.gray[400]};
	flex-shrink: 0;
	font-size: 12px;
`;
